import { NumberInput, TextInput } from '@core/components/Inputs';
import CurrencyTextField from '@core/components/Inputs/CurrencyTextField';
import ReadOnlyInput from '@core/components/Inputs/ReadOnlyInput';
import { FormControl, Grid, InputLabel, MenuItem, Select, Tooltip } from '@material-ui/core';
import SelectTransportadora from 'app/components/Select/SelectTransportadora';
import React from 'react';

const getCurrency = (value) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);

const DadosEntregaNota = ({
  values,
  onChange,
  onBlur,
  calcularValorTotal,
  handleChangeTipoDesconto,
  styles,
  errors,
  touched,
  submitCount,
}) => {
  const valorTotalText = values?.valorTotal !== undefined ? getCurrency(values?.valorTotal) : '-';

  const maximo9DigitosEsquerda = (values) => {
    return !values.floatValue || values.floatValue <= 10 ** 9;
  };

  const onlyNumberRegex = /^\d+$/;

  const _errors = {
    valorDesconto: (submitCount > 0 || touched?.valorDesconto) && errors?.valorDesconto,
    vendedor: (submitCount > 0 || touched?.vendedor) && errors?.vendedor,
  };

  const renderCampoFrete = () => {
    return (
      <CurrencyTextField
        id="valorFrete"
        name="valorFrete"
        value={values?.valorFrete}
        currencySymbol=""
        outputFormat="number"
        decimalCharacter=","
        digitGroupSeparator="."
        maximumValue="999999999"
        minimumValue="0"
        decimalPlaces={2}
        decimalPlacesShownOnBlur={2}
        decimalPlacesShownOnFocus={2}
        onChange={(e, value) => {
          const event = {
            target: {
              id: e.target.id,
              value: e.target.value === '' ? '' : value,
            },
          };
          onChange(event);
          calcularValorTotal(event);
        }}
        onBlur={onBlur}
        fullWidth
        variant="outlined"
        label="Frete (R$)"
        disabled={!values?.habilitarFrete}
      />
    );
  };

  return (
    <>
      <Grid container spacing={3} className="mb-8">
        <Grid item xs={3}>
          {values?.habilitarFrete ? (
            renderCampoFrete()
          ) : (
            <Tooltip title="É possível informar o frete somente quando existe venda de produto." placement="top">
              <div>{renderCampoFrete()}</div>
            </Tooltip>
          )}
        </Grid>
        <Grid item xs={3}>
          <FormControl variant="outlined" style={{ width: '100%' }}>
            <InputLabel id="tipoDesconto">Tipo do desconto</InputLabel>
            <Select
              id="tipoDesconto"
              name="tipoDesconto"
              label="Tipo do desconto"
              labelId="tipo-desconto"
              value={values?.tipoDesconto}
              onChange={handleChangeTipoDesconto}
              onBlur={onBlur}
              disabled={!values?.habilitarTipoDesconto}
              displayEmpty
            >
              <MenuItem value=" ">
                <em>‎ </em>
              </MenuItem>
              <MenuItem value="PERCENTUAL">Percentual (%)</MenuItem>
              <MenuItem value="VALOR">Valor (R$)</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={3}>
          {values?.tipoDesconto === 'VALOR' ? (
            <CurrencyTextField
              id="valorDesconto"
              name="valorDesconto"
              value={values?.valorDesconto}
              currencySymbol=""
              outputFormat="number"
              decimalCharacter=","
              digitGroupSeparator="."
              minimumValue="0"
              decimalPlaces={4}
              decimalPlacesShownOnBlur={4}
              decimalPlacesShownOnFocus={4}
              error={_errors.valorDesconto}
              helperText={_errors.valorDesconto}
              onChange={(e, value) => {
                const event = {
                  target: {
                    id: e.target.id,
                    value: e.target.value === '' ? '' : value,
                  },
                };
                onChange(event);
                calcularValorTotal(event);
              }}
              onBlur={onBlur}
              fullWidth
              variant="outlined"
              label="Desconto"
              disabled={!values?.tipoDesconto}
            />
          ) : (
            <NumberInput
              label="Desconto"
              id="valorDesconto"
              decimalScale={8}
              decimalSeparator=","
              allowNegative={false}
              isAllowed={(values) => {
                return !values.floatValue || values.floatValue <= 100;
              }}
              value={values?.valorDesconto}
              onChange={(e) => {
                onChange(e);
                calcularValorTotal(e);
              }}
              onBlur={onBlur}
              disabled={!values?.tipoDesconto || values?.tipoDesconto === ' '} // foi necessário colocar dessa forma por causa da documentação
              error={_errors.valorDesconto}
              touched={!!_errors.valorDesconto}
            />
          )}
        </Grid>
        <Grid item xs={3}>
          <ReadOnlyInput
            className={styles.valorTotal}
            id="valorTotal"
            label="Valor total (R$)"
            value={valorTotalText}
          />
        </Grid>
      </Grid>
      <Grid container spacing={3} className="mb-8">
        <Grid item xs={5}>
          <FormControl variant="outlined" style={{ width: '100%' }}>
            <InputLabel id="responsavelFreteLabel">Responsável pelo frete</InputLabel>
            <Select
              id="responsavelFrete"
              name="responsavelFrete"
              label="Responsável pelo frete"
              labelId="responsavelFreteLabel"
              value={values?.responsavelFrete}
              onChange={onChange}
              onBlur={onBlur}
            >
              <MenuItem value=" ">
                <em>‎ </em>
              </MenuItem>
              <MenuItem value="EMITENTE">Por conta do emitente</MenuItem>
              <MenuItem value="DESTINATARIO_REMETENTE">Por conta do destinatário/remetente</MenuItem>
              <MenuItem value="TERCEIROS">Por conta de terceiros</MenuItem>
              <MenuItem value="SEM_FRETE">Sem frete</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={7}>
          <SelectTransportadora
            id="transportadora"
            fullWidth
            label="Transportadora"
            onChange={onChange}
            onBlur={onBlur}
            value={values?.transportadora}
          />
        </Grid>
      </Grid>
      <Grid container spacing={3} className="mb-8">
        <Grid item xs={3}>
          <TextInput
            id="quantidadeVolumeTransportado"
            name="quantidadeVolumeTransportado"
            label="Quantidade de volumes transportados"
            maxLength={5}
            pattern={onlyNumberRegex}
            value={values.quantidadeVolumeTransportado}
            onChange={onChange}
            onBlur={onBlur}
            touched={touched.fiscal?.quantidadeVolumeTransportado}
            error={errors.fiscal?.quantidadeVolumeTransportado}
          />
        </Grid>
        <Grid item xs={3}>
          <TextInput
            id="tipoVolumeTrasportado"
            name="tipoVolumeTrasportado"
            onChange={onChange}
            onBlur={onBlur}
            value={values?.tipoVolumeTrasportado}
            error={_errors?.tipoVolumeTrasportado}
            touched={!!_errors?.tipoVolumeTrasportado}
            maxLength={50}
            placeholder="Caixas, barril, pacotes..."
            fullWidth
            variant="outlined"
            label="Tipo de volumes transportados"
          />
        </Grid>
        <Grid item xs={3}>
          <NumberInput
            label="Peso bruto total (kg)"
            id="pesoBruto"
            decimalScale={6}
            isAllowed={maximo9DigitosEsquerda}
            decimalSeparator=","
            allowNegative={false}
            value={values.pesoBruto}
            onChange={onChange}
            onBlur={onBlur}
            touched={touched.pesoBruto}
            error={errors.pesoBruto}
          />
        </Grid>
        <Grid item xs={3}>
          <NumberInput
            label="Peso líquido total (kg)"
            id="pesoLiquido"
            decimalScale={6}
            isAllowed={maximo9DigitosEsquerda}
            decimalSeparator=","
            allowNegative={false}
            value={values.pesoLiquido}
            onChange={onChange}
            onBlur={onBlur}
            touched={touched.pesoLiquido}
            error={errors.pesoLiquido}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default DadosEntregaNota;
